/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { FunctionComponent } from 'react';
import { Link } from 'react-router-dom';

export const SignUp: FunctionComponent = () => {
  return (
    <label style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', lineHeight: '1.3' }}>
      {`Don't have an account?`}
      <Link to="/sign-up">
        <label className="theme-color" style={{ paddingBottom: '10px', cursor: 'pointer' }}>
          Sign up
        </label>
      </Link>
    </label>
  );
};
